import * as Api from '@ViewModels';
import { StyleSheet, css } from 'aphrodite';
import { THEME } from '../../../../components-v2/Theme/theme';

const { colors, spacing } = THEME;

interface ContactFilterOptionProps {
	canEdit: boolean;
	skipStepContactFilter: Api.IContactsFilterRequest | null | undefined;
	stepUuid: string;
	stepIsBusy: boolean;
	onFilterChange: (filter: Api.IContactsFilterRequest | null) => void;
}

/**
 * Placeholder component for contact filter options in automation steps.
 * This component allows configuring conditional logic to skip steps based on contact criteria.
 *
 * TODO: Implement full UI for filter configuration when requirements are defined.
 * TODO: Wire up onFilterChange callback to enable editing filter criteria.
 * TODO: Use stepUuid for proper component identification when implementing UI.
 */
export function ContactFilterOption({
	canEdit,
	skipStepContactFilter,
	stepUuid: _stepUuid,
	stepIsBusy,
	onFilterChange: _onFilterChange,
}: ContactFilterOptionProps) {
	// Placeholder implementation
	// In a full implementation, this would render a UI for:
	// - Selecting contact properties to filter on (tags, custom fields, etc.)
	// - Choosing filter operators (equals, contains, etc.)
	// - Setting filter values

	// Safely stringify filter criteria with error handling
	const filterCriteriaDisplay = (() => {
		if (!skipStepContactFilter) {
			return null;
		}
		try {
			return JSON.stringify(skipStepContactFilter.criteria || {});
		} catch {
			return '[Unable to display filter criteria]';
		}
	})();

	return (
		<div className={css(styleSheet.container)}>
			<div className={css(styleSheet.header)}>
				Conditional Filter {skipStepContactFilter ? '(Active)' : '(Not configured)'}
			</div>
			{skipStepContactFilter && (
				<div className={css(styleSheet.criteriaText)}>Filter criteria: {filterCriteriaDisplay}</div>
			)}
			{canEdit && !stepIsBusy && (
				<div className={css(styleSheet.placeholderText)}>Contact filter configuration UI not yet implemented.</div>
			)}
		</div>
	);
}

const styleSheet = StyleSheet.create({
	container: {
		padding: spacing.md,
		backgroundColor: colors.background.main,
		borderRadius: 4,
		border: `1px solid ${colors.border.light}`,
	},
	header: {
		fontSize: 14,
		color: colors.text.light,
		marginBottom: spacing.sm,
	},
	criteriaText: {
		fontSize: 12,
		color: colors.text.light,
	},
	placeholderText: {
		fontSize: 12,
		color: colors.text.light,
		marginTop: spacing.sm,
	},
});
